import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import {
  multiIOMapping,
  multiMultiIOHwTypeMappingSelect,
  multiIOHwTypeMappping
} from '../Constants/constants.js';

function getHwTypeFromFunc(func) {
  const key = multiIOMapping[func] ?? multiIOMapping['default'];
  for (const [hwType, keys] of Object.entries(multiMultiIOHwTypeMappingSelect)) {
    if (keys.includes(key)) {
      return hwType;
    }
  }
  return 'undefined';
}

// Usage in OverwrIOContent
function OverwrIOContent({ controller, parent, func }) {
  let { t } = useTranslation();
  const hwType = getHwTypeFromFunc(func);
  return (
    <React.Fragment>
      <label>{t(hwType)}</label>
    </React.Fragment>
  );
}

export function OverwrIOHeading({ controller, parent, func, content }) {
  return (
    <Typography>
      <OverwrIOContent controller={controller} parent={parent} func={func} />
    </Typography>
  );
}

function OverwrMultiIOContent({ controller, parent, index, memo, type }) {
  let { t } = useTranslation();
  return (
    <React.Fragment>
      <label>{t(multiIOHwTypeMappping[type] ?? multiIOHwTypeMappping['default'])}</label>
      <Typography>{t('multifunctional_io') + ' ' + index}</Typography>
      {memo !== -1 && memo !== '' && <>{'(' + memo + ')'}</>}
    </React.Fragment>
  );
}

export function OverwrMultiIOHeading({ controller, parent, index, memo, type, content }) {
  return (
    <Typography gutterBottom>
      <OverwrMultiIOContent
        controller={controller}
        parent={parent}
        index={index}
        memo={memo}
        type={type}
      />
    </Typography>
  );
}
